import React, { FC, Fragment } from "react";
import { FieldSet, Input } from "../../../../forms";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import TEXT from "../../../text-consts";
import "./ContantInfo.less";

interface ContactInfoProps {
    headingText: string;
    isReadOnly: boolean;
}

const ContactInfo: FC<ContactInfoProps> = ({ headingText, isReadOnly }) => (
    <FieldSet name="contactInfo" legend={headingText}>
        {!isReadOnly && (
            <Fragment>
                <Input
                    className="contact-info__email-field"
                    disabled={isReadOnly}
                    type="email"
                    name={VALIDATION_FIELD.CONTACT_EMAIL}
                    label={`${TEXT.CONTACT_INFO.EMAIL}:`}
                    helpText="Vi sender ordrebekreftelse til denne adressen."
                    data-di-mask
                />
                <Input
                    className="contact-info__phone-field"
                    disabled={isReadOnly}
                    type="tel"
                    name={VALIDATION_FIELD.CONTACT_PHONE}
                    label={`${TEXT.CONTACT_INFO.PHONE}:`}
                    data-di-mask
                />
            </Fragment>
        )}
    </FieldSet>
);

export default ContactInfo;
